type CryptoLike = {
  randomUUID?: (() => string) | undefined;
  getRandomValues?: ((array: Uint8Array<ArrayBuffer>) => Uint8Array<ArrayBuffer>) | undefined;
};

let warnedWeakCrypto = false;

export function generateUUID(cryptoLike: CryptoLike | null = globalThis.crypto): string {
  if (cryptoLike && typeof cryptoLike.randomUUID === "function") {
    return cryptoLike.randomUUID();
  }

  if (cryptoLike && typeof cryptoLike.getRandomValues === "function") {
    const bytes = new Uint8Array(16);
    cryptoLike.getRandomValues(bytes);
    const view = new DataView(bytes.buffer);
    view.setUint8(6, (view.getUint8(6) & 0x0f) | 0x40); // version 4
    view.setUint8(8, (view.getUint8(8) & 0x3f) | 0x80); // variant 1
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  if (!warnedWeakCrypto) {
    warnedWeakCrypto = true;
    console.warn("[uuid] crypto API missing; refusing insecure UUID generation");
  }
  throw new Error("Web Crypto is required for UUID generation");
}
